import Request from "services";
import { Endpoints } from "services/endpoints";
import { handleRequestError } from "utils";
import { AuditLogRequestParams, AuditLogResponseData, NotificationRequestParams, NotificationResponseData, ResolveAccountRequest, UploadFileResponse, VerifyBvnRequest} from "./types";
import { AxiosError, AxiosProgressEvent, GenericAbortSignal } from "axios";
import { Bank, BankAccount } from "interface/bank";
import { BaseResponse } from "interface/baseResponse";
import { Bvn } from "interface/bvnData";
import { AuditLog } from "interface/auditLog";

type Config = {
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
    onFailed?: (error: AxiosError) => void;
    signal?: AbortSignal
}
export const uploadFile = async (data: FormData, config?: Config) => {
    const {onFailed, ...props} = config ?? {};
    try {
        const response = await Request.post<UploadFileResponse>(Endpoints.uploadFile, {
            data,
            ...props,
        });
        return response;
    } catch (error) {
        if(onFailed) {
            onFailed(error as any)
        } else {
            handleRequestError(error);
        }
    }
}

export const fetchBanks = async () => {
    try {
        const response = await Request.get<Array<Bank>>(Endpoints.banks);
        return response;
    } catch (error) {
        // handleRequestError(error)
    }
}

export const resolveAccount = async (data: ResolveAccountRequest, onError?: (error: AxiosError<BaseResponse>) => void) => {
    try {
        const response = await Request.post<BankAccount>(Endpoints.resolveAccountName, {data});
        return response;
    } catch (error) {
        onError && onError(error as any);
        // handleRequestError(error)
    }
};

export const verifyBvn = async (data: VerifyBvnRequest) => {
    try {
        const response = await Request.postWithUserToken<Bvn>(Endpoints.verifyBvn, {data});
        return response;
    } catch (error) {
        handleRequestError(error);
    }
};

export const auditLogs = async (params: AuditLogRequestParams, signal?: GenericAbortSignal) => {
    try {
        const response = await Request.getWithUserToken<AuditLogResponseData>(Endpoints.auditLogs, {params, signal});
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}

export const auditLog = async (auditlogId: string) => {
    try {
        const response = await Request.getWithUserToken<AuditLog>(Endpoints.auditLog(auditlogId));
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}

export const getNotifications = async (params: NotificationRequestParams) => {
    try {
        const response = await Request.getWithUserToken<NotificationResponseData>(Endpoints.notifications, {params});
        return response;
    } catch (error) {
        // handleRequestError(error);
    }
}

export const getNotification = async (notificationId: string) => {
    try {
        const response = await Request.getWithUserToken<Notification>(Endpoints.notification(notificationId));
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}

export const markNotification = async (notificationId: string) => {
    try {
        const response = await Request.putWithUserToken<Notification>(Endpoints.markNotificationRead(notificationId));
        return response;
    } catch (error) {
        handleRequestError(error);
    }
}
